export default class BcpModal extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.watchers();
    }

    watchers() {
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.HegydCore.initRemoteModal(
                '#modal',
                this.href,
                null,
                (data) => {
                    toastr.success('Demande transférée');
                },
                () => {
                    toastr.error('Une erreur s\'est produite');
                },
            );
        });
    }
}
